import apiEndpoints from "@/services/apiEndpoints";

export default {
  methods: {
    backToList() {
      const route = this.isAccessByCarManager ? 'schedule.car.list' : 'schedules';

      this.$router.push({
        name: route,
      })
    },
    onSelectedVehicles(data) {
      const indexSchedule = this.schedules.findIndex(x => x.id === data.currentSchedule.id);

      if (indexSchedule === -1) return;

      this.schedules[indexSchedule].assigned_cars_by_schedule = data.dataSelected;
      // this.checkAvailable(indexSchedule);
    },
    onSelectedStaffs(data) {
      const indexSchedule = this.schedules.findIndex(x => x.id === data.currentSchedule.id);

      if (indexSchedule === -1) return;

      this.schedules[indexSchedule].assigned_staffs_by_schedule = data.dataSelected;
      // this.checkAvailable(indexSchedule);
    },
    
    async checkAvailable(indexSchedule){
      // 車両に対して運転可能なスタッフが選択されているかのチェック
      let staffs = this.schedules[indexSchedule].assigned_staffs_by_schedule;
      let cars = this.schedules[indexSchedule].assigned_cars_by_schedule;
      const {status, code, data} = await this.$http.get(apiEndpoints.checkCarAvailableUser, {
        staffs: staffs.map(item => item.id),
        cars: cars.map(item => item.id),
      });
      if (!status) {
        return this.errorToast(data.message);
      }
      if(!data.result.check){
        // falseの場合警告を表示する
        this.errors[`schedules.`+indexSchedule+`.assigned_staffs_by_schedule`] = ["車両の運転に必要な従業員が選択されていません"];
        return;
      }else{
        // エラーを取り除く
        delete this.errors[`schedules.`+indexSchedule+`.assigned_staffs_by_schedule`];
        return;
      }
    },

    async onSelectedWastesOrService(dateEvent) {
      const ids = [...dateEvent.wastes_or_services];
      this.isLoading = true;

      const url = apiEndpoints.wastes_or_services_by_work_order();
      const {status, data, code} = await this.$http.getWithLoading(url, {
        ids: ids
      });

      this.isLoading = false;
      if (!status) {
        return;
      }

      const newWastesOrServicesBySchedule = data.result.map((wasteOrService, index) => {
        let estimates = [];
        if (wasteOrService.waste_id && wasteOrService.waste.estimates.length) {
          estimates = wasteOrService.waste.estimates.map(estimate => {
            return {
              ...estimate,
              quantity: null,
              number_of_rental_containers: null,
            }
          });
        }

        let params = {
          comment_to_discharger_site_user: null,
          comment_to_user: null,
          disposal_site: wasteOrService.disposal_sites_by_waste_id ? wasteOrService.disposal_site : null,
          disposal_sites_by_waste_id: wasteOrService.disposal_sites_by_waste_id,
          id: this.$_.uniqueId(),
          measurement_quantity: null,
          number_of_manifest: !!wasteOrService.waste_id ? 1 : null, // 廃棄物の場合マニフェスト枚数のデフォルト値を1に設定
          schedule_id: null, // overwrite after when attach to schedules
          waste_estimates_by_schedule: estimates,
          waste_or_service_by_work_order: wasteOrService,
          wastes_or_services_by_work_order_id: wasteOrService.id,
          zz_quantity_confirmation_unit: wasteOrService.zz_jw_units,
          zz_quantity_confirmation_unit_id: wasteOrService.zz_quantity_confirmation_unit_id,
          new: true,
          origin_index: index,
          is_waste: !!wasteOrService.waste_id,
        };
        if (wasteOrService.service_id) {
          if (wasteOrService.service.estimates.length) {
            estimates = wasteOrService.service.estimates.map(estimate => {
              return {
                ...estimate,
                quantity: null,
                number_of_rental_containers: null,
              }
            });
          }
          params.service_id = wasteOrService.service_id;
          params.waste_estimates_by_schedule = estimates;
        }

        return params;
      });

      this.schedules.filter(x => this.canBeUpdate(x)).forEach(schedule => {
        const cloneNewWastesOrServicesBySchedule = this.$_.cloneDeep(newWastesOrServicesBySchedule)
        schedule.waste_or_services_by_schedule = [
          ...schedule.waste_or_services_by_schedule,
          ...cloneNewWastesOrServicesBySchedule.map(x => ({...x, schedule_id: schedule.id})),
        ]
      });

      this.$refs.modalSelectWasteOrService.closeModal();
    },
    onSelectedTransportTreatment(data) {
      const indexSchedule = this.schedules.findIndex(x => x.id === data.scheduleInfo.schedule.id);
      if (indexSchedule === -1) return;
      const indexWasteOrService = this.schedules[indexSchedule].waste_or_services_by_schedule.findIndex(x => x.id === data.scheduleInfo.wasteOrServiceBySchedule.id);
      if (indexWasteOrService === -1) return;

      this.schedules[indexSchedule].waste_or_services_by_schedule[indexWasteOrService].disposal_sites_by_waste_id = data.id;
      this.schedules[indexSchedule].waste_or_services_by_schedule[indexWasteOrService].disposal_site = data.selectedItem;
    },
    removeAssignedCar(schedule, assigned_car) {
      if (!this.canBeUpdate(schedule)) return;

      const index = schedule.assigned_cars_by_schedule.findIndex(x => x.id === assigned_car.id);
      if (index === -1) return;

      schedule.assigned_cars_by_schedule.splice(index, 1);
      
      const indexSchedule = this.schedules.findIndex(x => x.id === schedule.id);

      // this.checkAvailable(indexSchedule);
    },
    removeAssignedStaff(schedule, assigned_staff) {
      if (!this.canBeUpdate(schedule)) return;

      const index = schedule.assigned_staffs_by_schedule.findIndex(x => x.id === assigned_staff.id);
      if (index === -1) return;

      schedule.assigned_staffs_by_schedule.splice(index, 1);

      const indexSchedule = this.schedules.findIndex(x => x.id === schedule.id);

      // this.checkAvailable(indexSchedule);
    },
    displayAssignedCar(assigned_car) {
      const carType = assigned_car.zz_car_type?.car_type;
      const carInfo = [assigned_car.area_name, assigned_car.classification_number, assigned_car.hiragana, assigned_car.number,].filter(x => !!x).join('－');

      return [
        carType,
        carInfo
      ].filter(x => !!x).join(' ');
    },
    displayWasteOrServiceName(waste_or_service_by_schedule) {
      const wasteOrService = waste_or_service_by_schedule.waste_or_service_by_work_order;

      if (wasteOrService.waste) {
        return wasteOrService.waste.name;
      }
      if (wasteOrService.service) {
        return wasteOrService.service.name;
      }

      return '';
    },
    displayWasteCategory(waste_or_service_by_schedule) {
      const wasteOrService = waste_or_service_by_schedule.waste_or_service_by_work_order;

      if (wasteOrService.waste) {
        return wasteOrService.waste?.waste_category?.name_abbreviated;
      }

      return '';
    },
    getDestinationWasteOrServiceBySchedule(wasteOrServiceBySchedule, schedule) {
      if (!wasteOrServiceBySchedule.disposal_site) return '';

      let vendorSite = '';
      if (schedule.transport_and_hold_section && schedule.transport_and_hold_section.toString() === '2') {
        vendorSite = wasteOrServiceBySchedule.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_transport_and_hold2?.name_abbreviated;
      } else {
        vendorSite = wasteOrServiceBySchedule.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.name_abbreviated;
      }
      const treatmentMethod = wasteOrServiceBySchedule.disposal_site?.disposal_site_by_waste_category?.zz_treatment_method?.treatment_method;

      return [vendorSite, treatmentMethod].filter(x => !!x).join('/');
    },
    openSelectTransportTreatmentModal(wasteOrServiceBySchedule, schedule) {
      if (!this.isAccessByCarManager) return;
      const waste_id = wasteOrServiceBySchedule.waste_or_service_by_work_order.waste_id;
      if (!waste_id) return;
      this.$refs.transportsTreatments.openModal({
        waste_id: waste_id,
        selectedScheduleInfo: {
          schedule,
          wasteOrServiceBySchedule
        },
      });
    },
    openSelectAssignedCarsModal(schedule) {
      if (!this.isAccessByCarManager) return;
      this.$refs.vehicleList.openModal(schedule);
    },
    openSelectAssignedStaffsModal(schedule) {
      if (!this.isAccessByCarManager) return;
      this.$refs.staffList.openModal(schedule);
    },
    openSelectWasteOrServiceModal() {
      if (!this.isAccessByCarManager) return;
      if (!this.schedules.length) return;
      this.$refs.modalSelectWasteOrService.setDataSelected(this.schedules[0].waste_or_services_by_schedule);
      this.$nextTick(() => {
        this.$refs.modalSelectWasteOrService.openModal();
      })
    },
  },
  computed: {
    workReservationId() {
      return this.$route.params.work_reservation_id;
    },
    zzReservationStatus2() {
      const options = this.$store.getters['options/options_tables'].zz_reservation_status_2 ?? [];
      return options.filter(option => option.id !== '0');
    },
    work_detail_header() {
      return [
        {
          text: "見積明細番号",
          value: "ID",
          sortable: false,
          width: 20
        },
        {
          text: "請求書表示用商品名",
          value: "name",
          sortable: false
        },
        {
          text: "予定数量",
          value: "quantity",
          sortable: false,
          width: 10
        },
        {
          text: "単位",
          value: "unit",
          sortable: false,
          width: 10
        },
        {
          text: "空容器数量（事前申込済のみ）",
          value: "empty_container_quantity",
          sortable: false
        }
      ];
    },
    disableComment() {
      return this.isAccessByCarManager;
    },
    canAddWasteOrService() {
      return this.schedules.filter(x => x.zz_reservation_status_1_id !== this.$constant.zz_reservation_status_1.confirm).length > 0;
    }
  }
};
